import helper from './helper';

let timerResize,
    timerScroll;
window.addEventListener('load', function() {});

function timeoutResize() {}
window.addEventListener('resize', function() {
    clearTimeout(timerResize);
    timerResize = setTimeout(timeoutResize, 300);
});

function timeoutScroll() {}
window.addEventListener('scroll', function() {
    clearTimeout(timerScroll);
    timerScroll = setTimeout(timeoutScroll, 100);
});